import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  FetchBjMissionListParams,
  FetchMissionSponListParams,
  FetchMyMissionListParams,
  FetchPlayMissionListParams,
} from '../../apis/client-side/mission/type';

export const missionListQueryKeys = createQueryKeys('mission-list', {
  fetchMyMissionList: (params: FetchMyMissionListParams) => [params],
  fetchBjMissionList: (params: FetchBjMissionListParams) => [params],
  fetchPlayMissionList: (params: FetchPlayMissionListParams | string) => [params],
  fetchMissionSponList: (params: FetchMissionSponListParams) => [params],
});
